/* =====================================================================================================================
   MJP GIFT CARD NEL CARRELLO (snippets/mjp-gc-cart.liquid)

   * La carta si applica al carrello con l'API Storefront di Shopify (cartGiftCardCodesAdd), sullo stesso dominio del
     negozio (/api/<versione>/graphql.json): nessun host esterno. Il carrello del sito e quello dell'API Storefront sono
     lo stesso oggetto (id = gid://shopify/Cart/<token di /cart.js>, lo stesso che usa Kaching Cart), quindi la carta
     applicata qui arriva gia' scalata al checkout.
   * Shopify scala il saldo in automatico, fino al totale dell'ordine: non si puo' scegliere un importo parziale.
   * Nel carrello Kaching compare il riquadro "Hai una gift card MJP?":
       - dal telefono porta al lettore (/pages/gift-card#apply), che legge la carta e la applica a questo carrello;
       - dal computer apre un QR: il telefono lo inquadra, apre il lettore collegato a QUESTO carrello (il token del
         carrello viaggia nel frammento #c=..., che non arriva al server, e il lettore lo toglie subito dall'indirizzo),
         legge la carta e la applica; il computer se ne accorge da solo e mostra "Carta applicata".
   * Il codice della carta non passa mai dal computer e non si salva da nessuna parte (patto ERP, par. 5).
   ===================================================================================================================== */
(function () {
  'use strict';
  if (window.MJPGiftCart) return;

  var cfgEl = document.getElementById('mjp-gc-cfg');
  if (!cfgEl) return;
  var C;
  try { C = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var T = C.t || {};
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  var FIELDS = 'id totalQuantity attributes { key value } cost { totalAmount { amount currencyCode } } appliedGiftCards { id lastCharacters amountUsed { amount currencyCode } balance { amount currencyCode } }';

  function gql(query, variables) {
    var h = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
    if (C.token) h['X-Shopify-Storefront-Access-Token'] = C.token;
    return fetch('/api/' + (C.api || '2025-10') + '/graphql.json', {
      method: 'POST', headers: h, credentials: 'omit', cache: 'no-store',
      body: JSON.stringify({ query: query, variables: variables })
    }).then(function (r) {
      if (!r.ok) throw new Error('http ' + r.status);
      return r.json();
    }).then(function (j) {
      if (j.errors && j.errors.length) { var e = new Error('gql'); e.gql = j.errors; throw e; }
      return j.data;
    });
  }

  function gidOf(token) {
    token = String(token || '');
    return /^gid:\/\//.test(token) ? token : 'gid://shopify/Cart/' + token;
  }

  /* Il carrello di questo browser: id per l'API Storefront e numero di articoli */
  function myCart() {
    return fetch(ROOT + 'cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        /* una gift card MJP nel carrello non si paga con un'altra gift card (Condizioni d'uso) */
        var hasGift = (c.items || []).some(function (i) { return /^gift-card/.test(String(i.handle || '')) || /^GIFT-/.test(i.sku || '') || i.gift_card; });
        return { gid: gidOf(c.token), token: c.token, count: c.item_count || 0, total: c.total_price || 0, hasGift: hasGift };
      });
  }

  function status(gid) {
    return gql('query MjpGcStatus($id: ID!) { cart(id: $id) { ' + FIELDS + ' } }', { id: gid })
      .then(function (d) { return d.cart; });
  }

  /* Applica una carta. Risolve { ok, cart, card } ; card = la carta appena applicata (ultime 4 cifre uguali). */
  function apply(gid, code, keepDash) {
    code = String(code || '').toUpperCase().replace(keepDash ? /\s/g : /[\s-]/g, '');
    var tail = code.replace(/-/g, '').slice(-4);
    function done(res) {
      var cart = res && res.cart, errs = (res && res.userErrors) || [];
      var card = null;
      if (cart) (cart.appliedGiftCards || []).forEach(function (g) { if (String(g.lastCharacters).toUpperCase() === tail) card = g; });
      return { ok: !!card && !errs.length, cart: cart, card: card, errors: errs };
    }
    var add = 'mutation MjpGcAdd($id: ID!, $c: [String!]!) { cartGiftCardCodesAdd(cartId: $id, giftCardCodes: $c) { cart { ' + FIELDS + ' } userErrors { code field message } } }';
    var upd = 'mutation MjpGcUpd($id: ID!, $c: [String!]!) { cartGiftCardCodesUpdate(cartId: $id, giftCardCodes: $c) { cart { ' + FIELDS + ' } userErrors { code field message } } }';
    return gql(add, { id: gid, c: [code] })
      .then(function (d) { return done(d.cartGiftCardCodesAdd); })
      .catch(function (e) {
        /* Versione dell'API senza cartGiftCardCodesAdd: si usa Update (sostituisce le carte gia' applicate) */
        if (!e.gql) throw e;
        return gql(upd, { id: gid, c: [code] }).then(function (d) { return done(d.cartGiftCardCodesUpdate); });
      });
  }

  function remove(gid, ids) {
    return gql('mutation MjpGcRemove($id: ID!, $g: [ID!]!) { cartGiftCardCodesRemove(cartId: $id, appliedGiftCardIds: $g) { cart { ' + FIELDS + ' } userErrors { code field message } } }', { id: gid, g: ids })
      .then(function (d) { return d.cartGiftCardCodesRemove.cart; });
  }

  /* Importi nel formato del negozio (es. €5,00), come Kaching e il resto del sito */
  function formatCents(cents) {
    cents = Math.round(+cents || 0);
    function fmt(dec, th, ds) {
      var p = (cents / 100).toFixed(dec).split('.');
      return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th) + (p[1] ? ds + p[1] : '');
    }
    return String(C.money_format || '€{{amount_with_comma_separator}}').replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount': return fmt(2, ',', '.');
        case 'amount_no_decimals': return fmt(0, ',', '.');
        case 'amount_no_decimals_with_comma_separator': return fmt(0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(2, "'", '.');
        case 'amount_with_space_separator': return fmt(2, ' ', ',');
        default: return fmt(2, '.', ',');
      }
    }).replace(/<[^>]*>/g, '');
  }
  function money(m) { return m ? formatCents(Math.round(+m.amount * 100)) : ''; }

  /* ---------------------------------------------------------------------------------------------------------------
     Importo parziale: riserva sul saldo (patto ERP v3, par. 6)
     * reserve(code, cart, importo) -> l'ERP abbassa la gemella Shopify all'importo scelto e tiene da parte il resto;
       il tema salva reservation_id nell'attributo nascosto del carrello "_mjp_gc_reservation", poi applica la carta.
     * rinnovo all'apertura del carrello e prima del pagamento; rilascio quando il cliente toglie la carta;
       riserva non piu' attiva -> la carta si toglie dal carrello (altrimenti Shopify scalerebbe tutto il saldo).
     * il codice serve SOLO a reserve e non si conserva: dopo bastano reservation_id e cart_id.
     --------------------------------------------------------------------------------------------------------------- */
  var ERP = String(C.erp || 'https://erp.mjpcore.com/api/v1/public/giftcard').replace(/\/+$/, '');
  var ATTR = '_mjp_gc_reservation';

  function erp(path, opts) {
    return fetch(ERP + path, Object.assign({ mode: 'cors', credentials: 'omit', cache: 'no-store', headers: { 'Accept': 'application/json' } }, opts || {}))
      .then(function (r) {
        if (r.status === 429) return { ok: false, http: 429, reason: T.too_many };
        return r.json().catch(function () { return null; }).then(function (d) {
          if (d && typeof d === 'object') { d.http = r.status; return d; }
          throw new Error('erp ' + r.status);
        });
      });
  }
  function post(path, body) {
    return erp(path, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) });
  }
  function reserve(code, gid, cents) { return post('/reserve', { code: code, cart_id: gid, amount_cents: cents }); }
  function renew(rid, gid) { return post('/reservation/renew', { reservation_id: rid, cart_id: gid }); }
  function release(rid, gid) { return post('/release', { reservation_id: rid, cart_id: gid }); }
  function getReservation(rid, gid) { return erp('/reservation?id=' + encodeURIComponent(rid) + '&cart_id=' + encodeURIComponent(gid)); }

  function attrOf(cart) {
    var a = ((cart && cart.attributes) || []).filter(function (x) { return x.key === ATTR; })[0];
    return a && a.value ? a.value : null;
  }
  /* Scrive (o toglie, con value vuoto) l'attributo della riserva conservando gli altri attributi del carrello */
  function setAttr(gid, value, cart) { return setAttrKey(gid, ATTR, value, cart); }
  function setAttrKey(gid, key, value, cart) {
    var list = ((cart && cart.attributes) || []).filter(function (a) { return a.key !== key; }).map(function (a) { return { key: a.key, value: a.value }; });
    list.push({ key: key, value: value || '' });
    return gql('mutation MjpGcAttr($id: ID!, $a: [AttributeInput!]!) { cartAttributesUpdate(cartId: $id, attributes: $a) { cart { id } userErrors { message } } }', { id: gid, a: list });
  }

  /* Applica la carta per l'importo scelto. Risolve { ok, card, cart, reservation, reason } */
  function applyAmount(gid, code, cents, balanceCents) {
    if (!C.partial || !cents || cents >= balanceCents) {
      return apply(gid, code).then(function (r) { r.reservation = null; return r; });
    }
    return reserve(code, gid, cents).then(function (res) {
      if (!res || !res.ok) return { ok: false, reason: res && res.reason };
      var rid = res.reservation_id;
      var before = rid ? status(gid).then(function (c) { return setAttr(gid, rid, c); }) : Promise.resolve();
      return before.then(function () { return apply(gid, code); }).then(function (r) {
        r.reservation = res;
        if (!r.ok && rid) release(rid, gid).catch(function () {});
        return r;
      });
    });
  }

  /* Gift card del vecchio sistema (es. ONLINE-3FD7ADCE): codice digitato, va direttamente a Shopify (niente ERP,
     niente importo parziale). Si prova com'e' scritto e, se Shopify non lo riconosce, senza trattino. */
  function applyRaw(gid, raw) {
    var a = String(raw || '').toUpperCase().replace(/\s+/g, ''), b = a.replace(/-/g, '');
    var tries = a === b ? [a] : [a, b];
    function next(i) {
      return apply(gid, tries[i], true).then(function (r) { return r.ok || i + 1 >= tries.length ? r : next(i + 1); });
    }
    return next(0).then(function (r) { r.reservation = null; return r; });
  }

  /* Toglie carte dal carrello: prima rilascia la riserva, poi toglie le carte e l'attributo */
  function removeCards(gid, ids, cart) {
    var rid = attrOf(cart);
    return (rid ? release(rid, gid).catch(function () { return null; }) : Promise.resolve())
      .then(function () { return remove(gid, ids); })
      .then(function (c2) { return rid ? setAttr(gid, '', c2).then(function () { return c2; }, function () { return c2; }) : c2; });
  }

  /* Controllo della riserva del carrello di questo browser. mode 'renew' (carrello, pagamento) o 'get' (ritorno).
     Risolve { cart, gid, res, dropped }: dropped = la riserva non era piu' attiva e la carta e' stata tolta. */
  function syncReservation(mode) {
    return myCart().then(function (mc) {
      if (!mc.count) return { cart: null, gid: mc.gid, res: null };
      return status(mc.gid).then(function (cart) {
        var rid = attrOf(cart), cards = (cart && cart.appliedGiftCards) || [];
        if (!rid || !cards.length) return { cart: cart, gid: mc.gid, res: null };
        return (mode === 'renew' ? renew(rid, mc.gid) : getReservation(rid, mc.gid)).then(function (res) {
          if (res && res.ok && (res.status === 'active' || res.status === 'consumed')) return { cart: cart, gid: mc.gid, res: res };
          if (res && ((res.ok && res.status) || res.http === 404)) {
            return removeCards(mc.gid, cards.map(function (g) { return g.id; }), cart)
              .then(function (c2) { return { cart: c2, gid: mc.gid, res: res, dropped: true }; });
          }
          return { cart: cart, gid: mc.gid, res: null }; /* errore temporaneo: si lascia com'e' */
        });
      });
    });
  }
  /* Prima del pagamento: false se la riserva era scaduta (carta tolta) e il cliente va avvisato */
  function beforeCheckout() {
    if (!C.partial) return Promise.resolve(true);
    return syncReservation('renew').then(function (r) { return !r.dropped; }).catch(function () { return true; });
  }

  /* ---------------------------------------------------------------------------------------------------------------
     Consultazione dal computer col telefono (pagina "Leggi la tua carta"): il telefono legge la carta e scrive nel
     carrello del computer SOLO saldo, scadenza e ultime 4 cifre (attributo "_mjp_gc_view"); il computer li mostra e
     cancella subito l'attributo. Il codice della carta resta sul telefono.
     --------------------------------------------------------------------------------------------------------------- */
  var VIEW = '_mjp_gc_view';
  function sendView(gid, data) {
    return status(gid).then(function (cart) { return setAttrKey(gid, VIEW, JSON.stringify(data), cart); });
  }
  function cartAjax(attrs) {
    return fetch(ROOT + 'cart/update.js', {
      method: 'POST', credentials: 'same-origin', cache: 'no-store',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).then(function (r) { return r.json(); });
  }
  function viewAttr(value) { var a = {}; a[VIEW] = value; return cartAjax(a); }

  window.MJPGiftCart = { config: C, sendView: sendView, gidOf: gidOf, myCart: myCart, status: status, apply: apply, remove: remove, money: money,
    formatCents: formatCents, openQR: function (opts) { openQR(opts); },
    applyAmount: applyAmount, applyRaw: applyRaw, removeCards: removeCards, syncReservation: syncReservation, beforeCheckout: beforeCheckout,
    attrOf: attrOf, release: release };

  /* ---------------------------------------------------------------------------------------------------------------
     Riquadro nel carrello Kaching
     --------------------------------------------------------------------------------------------------------------- */
  var isPhone = function () { return window.matchMedia('(hover: none) and (pointer: coarse)').matches || window.innerWidth < 768; };
  var ICON_CARD = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="2.5" y="5" width="19" height="14" rx="2.5"/><path d="M6 15h1M9 15h1M12 15h3M6 9v2M8 9v2M10 9v2M12 9v2M14 9v2"/></svg>';
  var ICON_ARROW = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>';
  var ICON_X = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg>';
  var ICON_OK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  var block = null, lastCards = [], lastFetch = 0, fetching = false, synced = false, lastHasGift = false;

  function buildBlock() {
    var b = document.createElement('div');
    b.className = 'mjpgc';
    b.setAttribute('data-mjpgc', '');
    b.innerHTML =
      '<div class="mjpgc__list" data-mjpgc-list></div>' +
      '<button type="button" class="mjpgc__cta" data-mjpgc-open>' +
        '<span class="mjpgc__ico">' + ICON_CARD + '</span>' +
        '<span class="mjpgc__txt"><span class="mjpgc__t">' + esc(T.cta_title) + '</span>' +
        '<span class="mjpgc__s" data-mjpgc-sub></span></span>' +
        '<span class="mjpgc__go">' + ICON_ARROW + '</span>' +
      '</button>';
    b.querySelector('[data-mjpgc-open]').addEventListener('click', function () {
      if (isPhone()) { window.location.href = ROOT + 'cart'; return; } /* sul telefono la carta si legge dalla pagina carrello */
      if (C.qr_on) openQR();
    });
    return b;
  }

  function renderList() {
    if (!block) { patchKaching(); return; }
    var list = block.querySelector('[data-mjpgc-list]');
    block.querySelector('[data-mjpgc-sub]').textContent = isPhone() ? T.cta_text_mob : T.cta_text_desk;
    var cta = block.querySelector('[data-mjpgc-open]');
    cta.hidden = (!isPhone() && !C.qr_on) || lastCards.length > 0 || lastHasGift; /* QR spento, carta gia' applicata, o gift card nel carrello */
    list.innerHTML = lastCards.map(function (g) {
      return '<div class="mjpgc__row">' +
        '<span class="mjpgc__chip">' + ICON_OK + '</span>' +
        '<span class="mjpgc__rt"><span class="mjpgc__rl">' + esc(T.row_label) + ' •••• ' + esc(String(g.lastCharacters).toUpperCase()) + '</span>' +
        '<span class="mjpgc__rn">' + esc(T.row_note) + '</span></span>' +
        '<span class="mjpgc__amt">−' + esc(money(g.amountUsed)) + '</span>' +
        '<button type="button" class="mjpgc__rm" data-mjpgc-rm="' + esc(g.id) + '" aria-label="' + esc(T.remove) + ' ' + esc(g.lastCharacters) + '">' + ICON_X + '</button>' +
      '</div>';
    }).join('');
    list.hidden = !lastCards.length;
    block.hidden = cta.hidden && list.hidden;
    patchKaching();
  }

  function refreshApplied(force) {
    if (fetching) return;
    if (!force && Date.now() - lastFetch < 4000) return;
    fetching = true; lastFetch = Date.now();
    var first = !synced; synced = true;
    (first && C.partial
      ? syncReservation('get').then(function (r) { return myCart().then(function (c) { lastHasGift = c.hasGift; return r.cart; }); })
      : myCart().then(function (c) { lastHasGift = c.hasGift; return c.count ? status(c.gid) : null; }))
      .then(function (cart) {
        lastCards = (cart && cart.appliedGiftCards) || [];
        /* Gift card MJP nel carrello: le carte applicate si tolgono (una gift card non si paga con un'altra) */
        if (lastHasGift && lastCards.length) {
          var ids = lastCards.map(function (g) { return g.id; });
          return myCart().then(function (c) { return removeCards(c.gid, ids, cart); })
            .then(function (c2) { lastCards = (c2 && c2.appliedGiftCards) || []; renderList(); kachingRefresh(); });
        }
        renderList();
      })
      .catch(function () {})
      .then(function () { fetching = false; });
  }

  function kachingRefresh() {
    try { if (window.kachingCartApi && window.kachingCartApi.refreshCart) window.kachingCartApi.refreshCart(); } catch (e) {}
  }

  document.addEventListener('click', function (e) {
    var rm = e.target.closest && e.target.closest('[data-mjpgc-rm]');
    if (!rm) return;
    rm.disabled = true;
    myCart().then(function (c) { return status(c.gid).then(function (cart) { return removeCards(c.gid, [rm.getAttribute('data-mjpgc-rm')], cart); }); })
      .then(function (cart) { lastCards = (cart && cart.appliedGiftCards) || []; renderList(); kachingRefresh(); })
      .catch(function () { rm.disabled = false; });
  });

  /* Pulsante "Checkout" di Kaching: Kaching non sa della gift card e mostra il totale pieno. Con una carta applicata
     il totale di Kaching resta (barrato, grigio) e accanto compare quello da pagare. Il testo e' di Kaching (Svelte):
     non si tocca il suo nodo di testo oltre al contenuto, e si rifa' ogni volta che Kaching lo riscrive. */
  var MONEY_RE = /(€\s?[\d.,'\s]*\d|[\d.,'\s]*\d\s?€)/;
  function patchKaching() {
    var btn = document.querySelector('#kaching-cart .kaching-cart__checkout-button');
    if (!btn) return;
    var ours = btn.querySelector('[data-mjpgc-due]');
    var used = 0;
    lastCards.forEach(function (g) { used += Math.round(+g.amountUsed.amount * 100); });
    /* il nodo di testo di Kaching con l'importo */
    var tn = null, w = document.createTreeWalker(btn, NodeFilter.SHOW_TEXT, null), n;
    while ((n = w.nextNode())) {
      if (ours && ours.contains(n)) continue;
      if (MONEY_RE.test(n.nodeValue) || n.__mjpgcFull) { tn = n; break; }
    }
    if (!tn) return;
    var full = MONEY_RE.test(tn.nodeValue) ? tn.nodeValue : tn.__mjpgcFull;
    if (!used) {
      if (ours) ours.remove();
      if (tn.__mjpgcFull && tn.nodeValue !== tn.__mjpgcFull) tn.nodeValue = tn.__mjpgcFull;
      tn.__mjpgcFull = null;
      return;
    }
    var m = MONEY_RE.exec(full);
    var tot = parseInt(m[1].replace(/\D/g, ''), 10) || 0;
    var due = Math.max(0, tot - used);
    var prefix = full.slice(0, m.index), suffix = full.slice(m.index + m[1].length);
    var html = '<s class="mjpgc-was">' + esc(m[1].trim()) + '</s> <span class="mjpgc-now">' + esc(formatCents(due)) + '</span>' + esc(suffix);
    if (tn.nodeValue === prefix && ours && ours.innerHTML === html && ours.previousSibling === tn) return;
    tn.__mjpgcFull = full;
    tn.nodeValue = prefix;
    if (!ours) { ours = document.createElement('span'); ours.setAttribute('data-mjpgc-due', ''); ours.className = 'mjpgc-due'; }
    ours.innerHTML = html;
    if (tn.nextSibling !== ours) tn.parentNode.insertBefore(ours, tn.nextSibling);
  }

  /* Kaching ridisegna il carrello quando vuole: il riquadro si rimette sempre subito prima del footer */
  function ensure() {
    var root = document.getElementById('kaching-cart');
    if (!root) return;
    var footer = root.querySelector('.kaching-cart__footer');
    var mine = root.querySelectorAll('[data-mjpgc]');
    if (!footer) { Array.prototype.forEach.call(mine, function (n) { n.remove(); }); return; }
    if (mine.length === 1 && mine[0].nextElementSibling === footer) {
      if (root.getBoundingClientRect().width > 0) refreshApplied(false);
      return;
    }
    Array.prototype.forEach.call(mine, function (n) { n.remove(); });
    if (!block) block = buildBlock();
    footer.parentNode.insertBefore(block, footer);
    renderList();
    refreshApplied(true);
  }

  /* Senza riquadro nel carrello laterale si leggono comunque le carte applicate, per il totale sul pulsante */
  function ensureLight() {
    var root = document.getElementById('kaching-cart');
    if (!root || !root.querySelector('.kaching-cart__checkout-button')) return;
    if (root.getBoundingClientRect().width > 0) refreshApplied(false);
    patchKaching();
  }
  var pending = 0;
  new MutationObserver(function () {
    if (pending) return;
    pending = requestAnimationFrame(function () { pending = 0; if (C.drawer) ensure(); else ensureLight(); patchKaching(); });
  }).observe(document.body, { childList: true, subtree: true, characterData: true });
  if (C.drawer) ensure(); else ensureLight();

  /* ---------------------------------------------------------------------------------------------------------------
     QR dal computer
     --------------------------------------------------------------------------------------------------------------- */
  var dlg = null, poll = null, pollUntil = 0, known = {};

  function loadQR() {
    if (window.qrcode) return Promise.resolve(window.qrcode);
    return new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = C.qr; s.async = true;
      s.onload = function () { window.qrcode ? resolve(window.qrcode) : reject(new Error('qr')); };
      s.onerror = function () { reject(new Error('qr')); };
      document.head.appendChild(s);
    });
  }

  function buildDialog() {
    var d = document.createElement('dialog');
    d.className = 'mjpgc-dlg';
    d.setAttribute('aria-labelledby', 'mjpgc-dlg-t');
    d.innerHTML =
      '<button type="button" class="mjpgc-dlg__x" data-mjpgc-close aria-label="' + esc(T.close) + '">' + ICON_X + '</button>' +
      '<p class="mjpgc-dlg__eyebrow">' + esc(T.qr_eyebrow) + '</p>' +
      '<h2 class="mjpgc-dlg__t" id="mjpgc-dlg-t">' + esc(T.qr_title) + '</h2>' +
      '<div class="mjpgc-dlg__qr" data-mjpgc-qr><span class="mjpgc-spin" aria-hidden="true"></span></div>' +
      '<ol class="mjpgc-dlg__steps">' +
        '<li><b>1</b><span>' + esc(T.qr_step_1) + '</span></li>' +
        '<li><b>2</b><span>' + esc(T.qr_step_2) + '</span></li>' +
        '<li><b>3</b><span data-mjpgc-s3>' + esc(T.qr_step_3) + '</span></li>' +
      '</ol>' +
      '<p class="mjpgc-dlg__st" data-mjpgc-st role="status" aria-live="polite"></p>';
    d.addEventListener('click', function (e) {
      if (e.target === d || (e.target.closest && e.target.closest('[data-mjpgc-close]'))) closeQR();
    });
    d.addEventListener('close', function () { stopPoll(); clearViewIfPending(); });
    d.addEventListener('cancel', function () { stopPoll(); });
    document.body.appendChild(d);
    return d;
  }

  function setStatus(kind, text, sub) {
    var st = dlg.querySelector('[data-mjpgc-st]');
    st.className = 'mjpgc-dlg__st' + (kind ? ' is-' + kind : '');
    st.innerHTML = (kind === 'wait' ? '<span class="mjpgc-dot" aria-hidden="true"></span>' : '') +
      '<span>' + esc(text) + '</span>' + (sub ? '<span class="mjpgc-dlg__sub">' + esc(sub) + '</span>' : '');
  }

  var qrMode = 'apply', qrOnResult = null, viewPending = false;
  function clearViewIfPending() { if (viewPending) { viewPending = false; viewAttr('').catch(function () {}); } }

  /* opts.mode: 'apply' (carrello: la carta si applica a questo carrello) o 'view' (consultazione: saldo e scadenza
     arrivano qui); opts.onResult(dati) per 'view' */
  function openQR(opts) {
    opts = opts || {};
    qrMode = opts.mode === 'view' ? 'view' : 'apply';
    qrOnResult = opts.onResult || null;
    if (!dlg) dlg = buildDialog();
    dlg.querySelector('[data-mjpgc-s3]').textContent = qrMode === 'view' ? (T.qrv_step_3 || T.qr_step_3) : T.qr_step_3;
    var box = dlg.querySelector('[data-mjpgc-qr]');
    box.classList.remove('is-done');
    box.innerHTML = '<span class="mjpgc-spin" aria-hidden="true"></span>';
    setStatus('', '');
    if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');

    if (qrMode === 'view') {
      /* "attesa" salva il carrello anche se vuoto, cosi' il telefono lo trova */
      viewPending = true;
      Promise.all([viewAttr('attesa'), loadQR()]).then(function (r) {
        var cart = r[0], qrcode = r[1];
        var q = qrcode(0, 'M'); q.addData(location.origin + C.reader + '#v=' + encodeURIComponent(cart.token)); q.make();
        box.innerHTML = q.createSvgTag({ cellSize: 1, margin: 0, scalable: true });
        setStatus('wait', T.qr_wait);
        startViewPoll();
      }).catch(function () { setStatus('err', T.error); });
      return;
    }

    Promise.all([myCart(), loadQR()]).then(function (r) {
      var cart = r[0], qrcode = r[1];
      var url = location.origin + C.reader + '#c=' + encodeURIComponent(cart.token);
      var q = qrcode(0, 'M'); q.addData(url); q.make();
      box.innerHTML = q.createSvgTag({ cellSize: 1, margin: 0, scalable: true });
      var svg = box.querySelector('svg'); if (svg) { svg.setAttribute('role', 'img'); svg.setAttribute('aria-label', T.qr_title || 'QR'); }
      return status(cart.gid).then(function (c) {
        known = {};
        ((c && c.appliedGiftCards) || []).forEach(function (g) { known[g.id] = 1; });
        setStatus('wait', T.qr_wait);
        startPoll(cart.gid);
      });
    }).catch(function () { setStatus('err', T.error); });
  }

  function closeQR() { stopPoll(); clearViewIfPending(); if (dlg && dlg.open && dlg.close) dlg.close(); else if (dlg) dlg.removeAttribute('open'); }

  function startViewPoll() {
    stopPoll();
    pollUntil = Date.now() + 10 * 60 * 1000;
    (function tick() {
      if (!dlg || !dlg.hasAttribute('open')) return;
      if (Date.now() > pollUntil) { clearViewIfPending(); setStatus('err', T.qr_expired); return; }
      if (document.hidden) { poll = setTimeout(tick, 2500); return; }
      fetch(ROOT + 'cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          var v = c.attributes && c.attributes[VIEW], d = null;
          if (v && v !== 'attesa') { try { d = JSON.parse(v); } catch (e) {} }
          if (!d) { poll = setTimeout(tick, 2500); return; }
          viewPending = false;
          viewAttr('').catch(function () {});
          var box = dlg.querySelector('[data-mjpgc-qr]');
          box.classList.add('is-done');
          box.insertAdjacentHTML('beforeend', '<span class="mjpgc-dlg__okbig" aria-hidden="true">' + ICON_OK + '</span>');
          setStatus('ok', T.qrv_done || T.qr_done);
          if (qrOnResult) qrOnResult(d);
          poll = setTimeout(closeQR, 1400);
        })
        .catch(function () { poll = setTimeout(tick, 5000); });
    })();
  }
  function stopPoll() { clearTimeout(poll); poll = null; }

  function startPoll(gid) {
    stopPoll();
    pollUntil = Date.now() + 10 * 60 * 1000;
    (function tick() {
      if (!dlg || !dlg.hasAttribute('open')) return;
      if (Date.now() > pollUntil) { setStatus('err', T.qr_expired); return; }
      if (document.hidden) { poll = setTimeout(tick, 3000); return; }
      status(gid).then(function (c) {
        var fresh = ((c && c.appliedGiftCards) || []).filter(function (g) { return !known[g.id]; });
        if (fresh.length) {
          var g = fresh[0];
          lastCards = c.appliedGiftCards; renderList(); kachingRefresh();
          document.dispatchEvent(new CustomEvent('mjp:gc-applied', { detail: { card: g, cart: c } }));
          var box = dlg.querySelector('[data-mjpgc-qr]');
          box.classList.add('is-done');
          box.insertAdjacentHTML('beforeend', '<span class="mjpgc-dlg__okbig" aria-hidden="true">' + ICON_OK + '</span>');
          setStatus('ok', T.qr_done, '•••• ' + String(g.lastCharacters).toUpperCase() + '  −' + money(g.amountUsed));
          poll = setTimeout(closeQR, 2200); /* si chiude da solo: il cliente resta sul carrello, gia' aggiornato */
          return;
        }
        poll = setTimeout(tick, 3000);
      }).catch(function () { poll = setTimeout(tick, 6000); });
    })();
  }
})();
